<div class="container-custom">
  <div class="row">
    <div class="col-12 d-flex justify-content-between">
      <h2 class="title">Detalle de barco</h2>
      <div *ngIf="isExportation && showAfterJan2026" class="rectification-indicator">
        <span
          class="px-3 py-2"
          [class.bg-success]="!blDetails.rectification"
          [class.bg-danger]="blDetails.rectification"
        >
          <i class="bi bi-circle-fill me-2 text-light pulse-animation"></i>
          Estatus Pedimento
        </span>
      </div>
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="operacion" class="form-label">Número de barco</label>
      <input
        type="number"
        id="operacion"
        class="form-control"
        [value]="blDetails.operation_number"
        disabled
      />
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="nombreBarco" class="form-label">Nombre de barco</label>
      <input
        type="text"
        id="nombreBarco"
        class="form-control"
        [value]="blDetails.boats_name"
        disabled
      />
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="nacionalidad" class="form-label">Nacionalidad</label>
      <input
        type="text"
        id="nacionalidad"
        class="form-control"
        [value]="blDetails.boat_nationality"
        disabled
      />
    </div>
    <div class="col-3 container-empty"></div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="puerto-origen" class="form-label">Puerto de embarque</label>
      <input
        type="text"
        id="puerto-origen"
        class="form-control"
        [value]="blDetails.port_origin_name"
        disabled
      />
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="puerto-destino" class="form-label">Puerto de destino</label>
      <input
        type="text"
        id="puerto-destino"
        class="form-control"
        [value]="blDetails.destination_port"
        disabled
      />
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="muelle" class="form-label">Muelle</label>
      <input
        type="text"
        id="muelle"
        class="form-control"
        [value]="blDetails.dock_name"
        disabled
      />
    </div>
    <div class="col-3 container-empty"></div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="fechaArribo" class="form-label">Fecha de arribo</label>
      <input
        type="text"
        id="fechaArribo"
        class="form-control"
        [value]="blDetails.notice_of_readiness | date : 'dd/MM/yyyy HH:mm a'"
        disabled
      />
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="fecha-atraque" class="form-label">Fecha de atraque</label>
      <input
        type="text"
        id="fecha-atraque"
        class="form-control"
        [value]="blDetails.docking_date | date : 'dd/MM/yyyy HH:mm a'"
        disabled
      />
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="fecha-desatraque" class="form-label"
        >Fecha de desatraque</label
      >
      <input
        type="text"
        id="fecha-desatraque"
        class="form-control"
        [value]="blDetails.undocking_date | date : 'dd/MM/yyyy HH:mm a'"
        disabled
      />
    </div>
    <h2 class="col-12 title">Información de operaciones</h2>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="inicio-operacion" class="form-label"
        >Inicio de operaciones</label
      >
      <input
        type="text"
        id="inicio-operacion"
        class="form-control"
        [value]="blDetails.start_operations | date : 'dd/MM/yyyy HH:mm a'"
        disabled
      />
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="fin-operaciones" class="form-label">Fin de operaciones</label>
      <input
        type="text"
        id="fin-operaciones"
        class="form-control"
        [value]="blDetails.end_operations | date : 'dd/MM/yyyy HH:mm a'"
        disabled
      />
    </div>
    <h2 class="col-12 title">Información de barco y clientes</h2>
    <ng-container *ngFor="let cliente of clientesBl; index as i">
      <div class="row" style="margin: 0; padding: 0">
        <div class="col-4 col-sm-3">
          <label [for]="'cliente-' + i" class="form-label">Clientes</label>
          <input
            type="text"
            [id]="'cliente-' + i"
            class="form-control"
            [value]="cliente.customer_name"
            disabled
          />
        </div>
        <div class="col-4 col-sm-3">
          <label [for]="'material-' + i" class="form-label">Material</label>
          <input
            type="text"
            [id]="'material-' + i"
            class="form-control"
            [value]="cliente.material_name"
            disabled
          />
        </div>
        <div class="col-4 col-sm-3">
          <label [for]="'presentacion-' + i" class="form-label"
            >Presentación</label
          >
          <input
            type="text"
            [id]="'presentacion-' + i"
            class="form-control"
            [value]="cliente.presentation"
            disabled
          />
        </div>
        <div class="col min">
          <label [for]="'unidades-' + i" class="form-label"># unidades</label>
          <input
            type="text"
            [id]="'unidades-' + i"
            class="form-control"
            [value]="cliente.quantity_pieces | number"
            disabled
          />
        </div>
        <div class="col min">
          <label [for]="'bl-' + i" class="form-label">Tonelaje</label>
          <input
            type="text"
            [id]="'bl-' + i"
            class="form-control"
            [value]="cliente.tonnage_bl | number : '1.3-3'"
            disabled
          />
        </div>
        <div class="col-auto text-center">
          <p class="detalle">Agregar lote</p>
          <a
            class="container-detalle"
            (click)="addBatch(cliente.id, cliente.id_presentation)"
          >
            <i class="bi bi-plus-lg"></i>
          </a>
        </div>
      </div>
    </ng-container>
    <div
      class="row text-center fs-4 text fw-semibold"
      *ngIf="!clientesBl.length"
    >
      <div class="col-text">Sin clientes asignados.</div>
    </div>
    <div class="table-header">
      <h2 class="title">Pesos</h2>
      <div class="container-buttons options">
        <button (click)="confirmUpdateShipBalance()">
          {{ updateShipMessage }}
        </button>
        <app-pre-sampling-record
          [blDetails]="blDetails"
        ></app-pre-sampling-record>
        <button
          *ngIf="blDetails.operation_type !== 'IMPORTACION'"
          (click)="navigateToRule238()"
        >
          Regla 2.3.8
        </button>
      </div>
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="toneladasTotales" class="form-label">Toneladas BL</label>
      <input
        type="text"
        id="toneladasTotales"
        class="form-control"
        [value]="blDetails.bl_tonnage | number : '1.3-3'"
        disabled
      />
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="toneladasSalidaTotales" class="form-label"
        >Toneladas de salida totales</label
      >
      <input
        type="text"
        id="toneladasSalidaTotales"
        class="form-control"
        [value]="blDetails.output_total_tonnage | number : '1.3-3'"
        disabled
      />
    </div>
    <div class="col-6 col-sm-4 col-md-3">
      <label for="toneladasRestantes" class="form-label"
        >Toneladas restantes</label
      >
      <input
        type="text"
        id="toneladasRestantes"
        class="form-control"
        [value]="blDetails.remaining_tonnage | number : '1.3-3'"
        disabled
      />
    </div>
    <div class="table-header">
      <h2 class="title">
        Lotes asignados
        <sup class="title__sub" *ngIf="lotesArray.length">{{
          lotesArray.length
        }}</sup>
      </h2>
      <div class="container-buttons options">
        <button
          (click)="downloadLayout()"
          *ngIf="isImportationPieces && createBatches"
        >
          Layout
        </button>
        <app-read-xlsx
          *ngIf="isImportationPieces && createBatches"
          [customersBl]="clientesBl"
          [blDetails]="blDetails"
          (onLoadFile)="onLoadFile($event)"
        ></app-read-xlsx>
        <button (click)="navigateToCustoms()" *ngIf="isExportation">
          Pedimentos
        </button>
        <button (click)="navigateToBill()" *ngIf="lotesArray.length">
          Facturación
        </button>
        <button
          (click)="confirmDeleteAllBatches()"
          *ngIf="lotesArray.length && isImportationPieces && deleteBatches"
        >
          Eliminar lotes
        </button>
      </div>
    </div>
    <div class="container-table">
      <app-table
        [table_config]="table_config"
        [array]="lotesArray"
        [loader]="loader"
        (onInfoLote)="confirm($event)"
      ></app-table>
    </div>
  </div>
</div>
<app-overlay
  *ngIf="loteEliminar"
  [buttons]="true"
  mensaje="¿Está seguro de eliminar el lote con No. de lote:{{ infoLote.id }}"
  (onDeleteLote)="deleteLote($event)"
></app-overlay>
<app-overlay
  *ngIf="deleteBatchesOverlay"
  [buttons]="true"
  mensaje="¿Está seguro de eliminar todos los lotes diferente a granel de este barco?"
  (onDeleteLote)="deleteAllBatches($event)"
></app-overlay>
<app-overlay
  icono="bi bi-info-circle-fill"
  mensaje="Solo se pueden agregar lotes de importación o cabotage de importación"
  *ngIf="addLote"
></app-overlay>
<app-overlay
  *ngIf="errorOverlay"
  [icono]="icono"
  [mensaje]="mensaje"
></app-overlay>
<app-overlay *ngIf="loading"></app-overlay>
<app-overlay
  icono="bi bi-info-circle-fill"
  mensaje="Sin autorización para esta acción."
  *ngIf="isAuthorized"
></app-overlay>
<app-overlay
  *ngIf="confirmUpdateShip"
  [buttons]="true"
  [mensaje]="confirmUpdateShipMessage"
  (onDeleteLote)="updateShipBalance($event)"
></app-overlay>
<app-overlay *ngIf="overlayError" [reload]="true"></app-overlay>
